import { z } from 'zod';
// eslint-disable-next-line import/prefer-default-export
export var NumericalIdSchema = z.coerce.number();
